import { infrastructuresRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { AttachOrganizationInfrastructureCostModel } from '../types';

export const useAttachOrganizationInfrastructureCost = () =>
  useMutation<void, unknown, AttachOrganizationInfrastructureCostModel>(
    (attachOrganizationInfrastructureCost) =>
      infrastructuresRepo.attachOrganizationInfrastructureCost(
        attachOrganizationInfrastructureCost,
      ),
  );
